import { useMutation, useQueryClient } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';
import { UpdateMyPreferencesInput } from '@/gql/graphql';

const UpdateMyPreferencesMutation = graphql(`
  mutation UpdateMyPreferences($input: UpdateMyPreferencesInput!) {
    updateMyPreferences(input: $input) {
      useNewDashboard
    }
  }
`);

export const useUpdateMyPreferences = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: UpdateMyPreferencesInput) => {
      return gqlClient.request(UpdateMyPreferencesMutation, {
        input,
      });
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: meKeys.all });
    },
  });
};
